import { CheckCircle2, AlertTriangle } from 'lucide-react';

// iter950 — Live reconciliation badge. Performs a real-time check of
// Grand Total Debits − Grand Total Credits (tolerance < 0.01). Green
// "Reconciled ✓" when balanced, red "Out of Balance ⚠" otherwise.
export function ReconciledBadge({ debit, credit, difference, className = '' }) {
  const d = Number(debit) || 0;
  const c = Number(credit) || 0;
  // F3 — an explicit ledger difference (excludes any synthetic Suspense plug) wins.
  const diff = Math.round(((difference ?? null) !== null ? Number(difference) || 0 : d - c) * 100) / 100;
  const balanced = Math.abs(diff) < 0.01;
  return (
    <span
      data-testid="reconciled-badge"
      data-balanced={balanced ? 'true' : 'false'}
      title={balanced ? 'Debits equal Credits' : `Difference: ${diff.toLocaleString()}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-bold ${
        balanced
          ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
          : 'bg-red-50 text-red-700 border-red-300'
      } ${className}`}
    >
      {balanced ? <CheckCircle2 size={13} /> : <AlertTriangle size={13} />}
      {balanced ? 'Reconciled ✓' : 'Out of Balance ⚠'}
    </span>
  );
}

export default ReconciledBadge;
